var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 2.667H8a2.675 2.675 0 00-2.667 2.666v21.334c0 1.466 1.2 2.666 2.667 2.666h16c1.467 0 2.667-1.2 2.667-2.666v-16l-8-8zm5.333 24H8V5.333h10.667v5.334H24v16zm-8-4A2.674 2.674 0 0113.333 20v-7.333A.66.66 0 0114 12a.66.66 0 01.667.667V20h2.666v-7.333a3.335 3.335 0 00-6.667 0V20A5.332 5.332 0 0016 25.333 5.332 5.332 0 0021.333 20v-5.333h-2.666V20c0 1.467-1.2 2.667-2.667 2.667z",
    fill: "currentColor"
  })));
}
export default SvgDocIcon;